import { combineReducers } from "redux";
import { profileReducer } from "./profile";
import { signupReducer } from "./signup";
import { targetingReducer } from "./targeting";
import { singleNotificationsReducer } from "./singleNotifications";
import { audiencesReducer } from "./audiences";
import { sendingsReducer } from "./sendings";
import { filtersReducer } from "./filters";
import { subscriptionsReducer } from "./subscriptions";
import audiencePixelsSliceReducer from "./audiencePixelsSlice";
import countriesSliceReducer from "./countriesSlice";
import countersSliceReducer from "./countersSlice";
import notixProfileSliceReducer from "./notixProfileSlice";
import urlSliceReducer from "./urlSlice";
import zoneSliceReducer from "./zonesSlice";
import zoneAdvSliceReducer from "./zonesAdvSlice";
import invoicesSliceReducer from "./invoicesSlice";
import alertSliceReducer from "./alertSlice";
import statisticSliceReducer from "./statisticSlice";
import statisticAdvSliceReducer from "./statisticAdvSlice";
import authorizeSliceReducer from "./authorizeSlice";
import monetizationRequestReducer from "./monetizationRequestSlice";

export const rootReducer = combineReducers({
  authorize: authorizeSliceReducer,
  stats: statisticSliceReducer,
  advStats: statisticAdvSliceReducer,
  profile: profileReducer,
  signup: signupReducer,
  countries: countriesSliceReducer,
  targeting: targetingReducer,
  zones: zoneSliceReducer,
  zonesAdv: zoneAdvSliceReducer,
  singleNotifications: singleNotificationsReducer,
  audiences: audiencesReducer,
  sendings: sendingsReducer,
  counters: countersSliceReducer,
  filters: filtersReducer,
  pixels: audiencePixelsSliceReducer,
  subscriptions: subscriptionsReducer,
  notixProfile: notixProfileSliceReducer,
  urlFetch: urlSliceReducer,
  invoices: invoicesSliceReducer,
  alert: alertSliceReducer,
  monetizationRequest: monetizationRequestReducer,
});
